module.exports = __webpack_public_path__ + "static/media/header-image.7ebdae45.png";